import { Link } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Drawer, Button, Avatar } from "@mui/material";

const DrawerMain = styled(Drawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    border: "none",
    overflow: "hidden",
    backgroundColor: "#fff",
    padding: "20px 30px",
    [theme.breakpoints.down("sm")]: {
      width: 300,
    },
    [theme.breakpoints.up("md")]: {
      width: 450,
    },
    [theme.breakpoints.up("lg")]: {
      width: 550,
    },
  },
}));
const HeaderSec = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  "& h6": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "20px",
    lineHeight: "27px",
    textTransform: "capitalize",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& button": {
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    textTransform: "capitalize",
    color: "#FF0000",
    fontFamily: theme.typography.fontFamily,
    backgroundColor: "transparent",
  },
}));

const ContactMain = styled("div")(({ theme }) => ({
  marginTop: "20px",
  "& .contactWrap:first-child": {
    marginTop: "0px",
  },
  "& .contactWrap": {
    marginTop: "13px",
  },
}));

const ContactWrap = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "20px",
  borderBottom: "1px solid #D9D9D9",
  paddingBottom: "13px",
  "& p": {
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },
  "& span": {
    fontStyle: "normal",
    fontWeight: 900,
    fontSize: "14px",
    lineHeight: "22px",
    color: "#0B0B0B",
    fontFamily: theme.typography.fontFamily,
  },

  "& .contactAction": {
    marginTop: "-6px",
  },
  "& .contactBtn": {
    marginTop: "-4px",
  },
}));

const UserAvatar = styled(Avatar)(({ theme }) => ({
  width: "50px",
  height: "50px",
  backgroundColor: "#0B0B0B",
  fontFamily: theme.typography.fontFamily,
}));
const ViewJobs = styled(Link)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "13px",
  lineHeight: "18px",
  textDecoration: "underline",
  color: "#0066FF",
  fontFamily: theme.typography.fontFamily,
}));
const ActionButton = styled(Button)(({ theme }) => ({
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "13px",
  lineHeight: "18px",
  fontFamily: theme.typography.fontFamily,
  padding: "4px 0px",
  margin: "2px 2px",
  textTransform: "capitalize",
  borderRadius: "50px",
  "&:first-child": { marginLeft: "0px" },
  "&.accept": {
    color: "#23AE00",
    background: "rgba(44, 220, 0, 0.2)",
  },
  "&.reject": {
    color: "#FF0000",
    background: "rgba(255, 0, 0, 0.1)",
  },
  "&.reject": {
    color: "#FF0000",
    background: "rgba(255, 0, 0, 0.1)",
  },
  "&.profile": {
    color: "#0066FF",
    background: "rgba(0, 102, 255, 0.1)",
    padding: "4px 8px",
  },
}));

export {
  DrawerMain,
  HeaderSec,
  ContactMain,
  ContactWrap,
  UserAvatar,
  ViewJobs,
  ActionButton,
};
